export const KEY_CODES = {
    ENTER: 13,
}
